import { render, staticRenderFns } from "./ShareReviewOrderSelector.vue?vue&type=template&id=49467741&"
import script from "./ShareReviewOrderSelector.vue?vue&type=script&lang=ts&"
export * from "./ShareReviewOrderSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ShareReviewOrderSelector.vue?vue&type=style&index=0&id=49467741&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports